<template>
  <!-- 小组课卡片组件 -->
  <div class="course-card">
    <router-link class="course-link" :to="{name: 'workshopDetail', params: {id: item.id}}">
      <div class="course-cover background-logo">
        <img class="cover-image" src="" v-lazy="item.thumb" alt="">
        <div class="new-workshop" v-if="item.is_new == 1 && item.status != 3">新课上线</div>
      </div>
      <div class="course-info">
        <div class="course-title">
          <div class="title">{{item.title}}</div>
          <div class="course-status" v-if="item.status == 2 && enrollEndSoon && (item.current < item.total) && !isStop">
            <span class="signing">即将报名截止</span>
          </div>
          <div class="course-status" v-else-if="item.status == 2 && (item.current >= item.total)">
            <span class="signing">名额已满</span>
          </div>
          <div class="course-status" v-else-if="item.status == 2 && !isStop">
            <span class="signing">报名中...</span>
          </div>
          <div class="course-status" v-else-if="item.status == 2 && isStop">
            <span class="stop-sign">报名截止</span>
          </div>
        </div>
        <div class="workshop-time">本地上课时间：<span v-if="item.status == 1 || item.status == 2">{{formatTime}}</span><span v-else-if="item.status == 3">待发布</span></div>
      </div>
    </router-link>
  </div>

</template>

<style lang="less" scoped></style>

<script>
  import Utils from '@/untils/utils'
  export default {
    props: {
      item: {
        type: Object,
        default: {},
      },
      now: {
        default: 0,
      }
    },
    computed: {
      enrollEndSoon() {
        // 报名截止前24小时，显示即将报名截止
        if ((this.item.starttime - 14400 - new Date().getTime() / 1000) <= (60 * 60 * 24)) {
          return true;
        }else {
          return false;
        }
      },
      isStop() {
        // 是否报名截止
        if ((this.item.starttime - 14400) <= (new Date().getTime() / 1000)) {
          return true;
        }else {
          return false;
        }
      },
      formatTime() {
        // 格式化开课时间
        // 如果开始时间大于现在，则显示“待发布”
        const starttimeStamp = this.item.starttime * 1000;
        const endtimeStamp = this.item.endtime * 1000;
        if (Date.now() <= starttimeStamp) {
          return `${Utils.formatTimeToDay(new Date(starttimeStamp))} ${Utils.formatTimeToMoinute(new Date(starttimeStamp))}-${Utils.formatTimeToMoinute(new Date(endtimeStamp))}`;
        }else {
          return '待发布';
        }
      }
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Course/Cards/workshopCard.vue